import { createRoute } from "@tanstack/react-router";

import { shellRoute } from "@platform/shell.route";
import { SettingsPage } from "./settings.page";

export const settingsRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/settings",
	component: SettingsPage,
});
